module.exports = __webpack_public_path__ + "assets/images/81e133472b1a6bddbbae73ae9c6fd22b.png";